import img_1 from "../assets/images/OurPartners/img_1.png";
import img_2 from "../assets/images/OurPartners/img_2.png";
import img_3 from "../assets/images/OurPartners/img_3.png";
import img_4 from "../assets/images/OurPartners/img_4.png";
import img_5 from "../assets/images/OurPartners/img_5.png";
import img_6 from "../assets/images/OurPartners/img_6.png";
import img_7 from "../assets/images/OurPartners/img_7.png";
import img_8 from "../assets/images/OurPartners/img_8.png";
import img_9 from "../assets/images/OurPartners/img_9.png";
import img_10 from "../assets/images/OurPartners/img_10.png";
import img_11 from "../assets/images/OurPartners/img_11.png";
import aws_certificate from "../assets/images/OurPartners/aws_certificate.png";

export const ourPartnersImg = [
    {
        id: 1,
        img: img_1,
    },
    {
        id: 2,
        img: img_9,
    },
    {
        id: 3,
        img: img_2,
    },
    {
        id: 4,
        img: img_3,
    },
    {
        id: 5,
        img: img_4,
    },
    {
        id: 6,
        img: img_5,
    },
    {
        id: 7,
        img: img_6,
    },
    {
        id: 8,
        img: img_7,
    },
    {
        id: 9,
        img: img_8,
    },
    {
        id: 10,
        img: img_10,
    },
    {
        id: 11,
        img: img_11,
    },
    {
        id: 12,
        img: aws_certificate,
    },
]